import React, { useState } from 'react';
import styles from './carousel.module.scss'
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import { isBrowser, getWindow, getDocument } from '../../utils/browser';

const Carousel = ({ testimonios }) => {
	const handleOnDragStart = e => e.preventDefault()
	let TestMaker = ({name, test, image}) => {
		return (
			<div onDragStart={handleOnDragStart} className={styles.testimonioContainer}>
				<img src={image}/>
				<div className={styles.menData}>
					<p className={styles.testim}>{`"${test}"`}</p>
					<p className={styles.namePerson}>{name}</p>
				</div>
			</div>
		)
	}
	const [tests, setTests] = useState(testimonios.map((el) => ( TestMaker(el))))
	const responsive = {
	  0: { items: 1 },
	  800: { items : 2 },
	  1024: { items: 3 },
	  1500: { items: 4 }
	}

	const handleColor = (e) => {
		if (!isBrowser()) return;
		try{
			const window = getWindow();
			const document = getDocument();
			if(window && window.innerWidth < 800){
				const elements = document.querySelectorAll('#carouselContainer .alice-carousel__stage .alice-carousel__stage-item.__active');
				if(elements[0] && elements[0].children[0]){
					elements[0].children[0].style.background = "#DE892A";
					if(elements[0].children[0].children[1]){
						if(elements[0].children[0].children[1].children[0]) elements[0].children[0].children[1].children[0].style.color = "#FFF";
						if(elements[0].children[0].children[1].children[1]) elements[0].children[0].children[1].children[1].style.color = "#FFF";
					}
				}
			}else if(window){
				const elements = document.querySelectorAll('#carouselContainer .alice-carousel__stage .alice-carousel__stage-item.__active');
				if(elements[1] && elements[1].children[0]){
					elements[1].children[0].style.background = "#DE892A";
					if(elements[1].children[0].children[1]){
						if(elements[1].children[0].children[1].children[0]) elements[1].children[0].children[1].children[0].style.color = "#FFF";
						if(elements[1].children[0].children[1].children[1]) elements[1].children[0].children[1].children[1].style.color = "#FFF";
					}
				}
			}
		}catch(e){

		}
	}

	const removeColor = (e) => {
		if (!isBrowser()) return;
		try{
			const window = getWindow();
			const document = getDocument();
			if(window && window.innerWidth < 800){
				console.log("entro")
				const elements = document.querySelectorAll('#carouselContainer .alice-carousel__stage .alice-carousel__stage-item.__active');
				if(elements[0] && elements[0].children[0]){
					elements[0].children[0].style.background = "#FFF";
					if(elements[0].children[0].children[1]){
						if(elements[0].children[0].children[1].children[0]) elements[0].children[0].children[1].children[0].style.color = "#7F8299";
						if(elements[0].children[0].children[1].children[1]) elements[0].children[0].children[1].children[1].style.color = "#23263E";
					}
				}
			}else if(window){
				const elements = document.querySelectorAll('#carouselContainer .alice-carousel__stage .alice-carousel__stage-item.__active');
				if(elements[1] && elements[1].children[0]){
					elements[1].children[0].style.background = "#FFF";
					if(elements[1].children[0].children[1]){
						if(elements[1].children[0].children[1].children[0]) elements[1].children[0].children[1].children[0].style.color = "#7F8299";
						if(elements[1].children[0].children[1].children[1]) elements[1].children[0].children[1].children[1].style.color = "#23263E";
					}
				}
			}
		}catch(e){

		}
	}

	const initColor = (e) => {
		if (!isBrowser()) return;
		try{
			setTimeout(function(){
				const window = getWindow();
				const document = getDocument();
				if(!window || !document) return;
				const stageElements = document.querySelectorAll('#carouselContainer .alice-carousel__stage');
				if(!stageElements[0]) return;
				const activeElements = stageElements[0].getElementsByClassName('alice-carousel__stage-item __active');
				if(window.innerWidth < 800){
					if(activeElements[0] && activeElements[0].children[0]){
						activeElements[0].children[0].style.background = "#DE892A"
						if(activeElements[0].children[0].children[1]){
							if(activeElements[0].children[0].children[1].children[0]) activeElements[0].children[0].children[1].children[0].style.color = "#FFF"
							if(activeElements[0].children[0].children[1].children[1]) activeElements[0].children[0].children[1].children[1].style.color = "#FFF"
						}
					}
				}else{
					if(activeElements[1] && activeElements[1].children[0]){
						activeElements[1].children[0].style.background = "#DE892A"
						if(activeElements[1].children[0].children[1]){
							if(activeElements[1].children[0].children[1].children[0]) activeElements[1].children[0].children[1].children[0].style.color = "#FFF"
							if(activeElements[1].children[0].children[1].children[1]) activeElements[1].children[0].children[1].children[1].style.color = "#FFF"
						}
					}
				}
			}, 1000)
		}catch(e){

		}
	}

	return (
		<div className={styles.container} id="carouselContainer">
			<AliceCarousel dotsDisabled buttonsDisabled autoPlay={true} duration={500} autoPlayInterval={7000} mouseDragEnabled responsive={responsive} items={tests} onInitialized={initColor} onSlideChanged={handleColor} onSlideChange={removeColor}>
			</AliceCarousel>
		</div>
	)
}

export default Carousel;
